import { getAboutLeagueRequest } from "../repositories/about_league_repository";
export const AboutLeagueService = () => {
    const fetchAboutLeague = async (setAboutLeagueData) => {
        try {
            const response = await getAboutLeagueRequest();
            if (response?.success) {
                setAboutLeagueData(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch about league data.")
        }
    }
    return {
        fetchAboutLeague,
    };
};